import shopifyOnboarding from './shopifyOnboarding';

export default shopifyOnboarding;
